export var PriceAdjustmentCalculationBasis;
(function (PriceAdjustmentCalculationBasis) {
    PriceAdjustmentCalculationBasis["PER_RULE_UNIT"] = "PER_RULE_UNIT";
    PriceAdjustmentCalculationBasis["PER_RESOURCE"] = "PER_RESOURCE";
    PriceAdjustmentCalculationBasis["PER_RESOURCE_IN_GROUP"] = "PER_RESOURCE_IN_GROUP";
})(PriceAdjustmentCalculationBasis || (PriceAdjustmentCalculationBasis = {}));
